<template>
  <div v-if="logueado" class="colorGradient">
    <v-row>
      <v-col cols="auto">
        <div>
          <v-breadcrumbs :items="items">
            <template v-slot:divider>
              <v-icon>mdi-forward</v-icon>
            </template>
          </v-breadcrumbs>
        </div>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto" class="mr-5">
        <div>
          <v-btn outlined @click="cerrarSesion()" dark>Cerrar sesion</v-btn>
        </div>
      </v-col>
    </v-row>

    <h1 class="text-center">ASISTENCIAS EN PROCESO</h1>
    <v-row class="mx-3">
      <v-col
        v-for="(item, index) in asistencias"
        :key="index"
        class="d-flex child-flex"
        cols="12"
        md="4"
      >
        <v-card elevation="5" shaped>
          <v-card-text class="pa-2">
            <v-list three-line>
              <v-list-item class="px-1 pt-0">
                <v-list-item-content class="py-0">
                  <v-list-item-subtitle class="headline">
                    Poliza: {{ item.poliza }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="headline">
                    Tipo de asistencia: {{ item.tipoAsistencia }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="headline">
                    País: {{ item.pais }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="headline">
                    Titular póliza: {{ item.titularPoliza }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="headline">
                    Placa: {{ item.placa }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="headline">
                    Marca: {{ item.marca }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="headline">
                    Modelo: {{ item.modelo }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="headline">
                    Color: {{ item.color }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
  <div v-else class="mx-auto my-auto">
    <h1>PAGINA NO DISPONIBLE</h1>
    <p>DEBE INICIAR SESION</p>
  </div>
</template>
<script>
import { dbRefAppMovil, dbAssa } from "../main";
import router from "../router";
export default {
  data() {
    return {
      logueado: false,
      items: [
        {
          text: "Inicio",
          disabled: false,
          href: "/",
        },
        {
          text: "Assa Asistencias",
          disabled: true,
          href: "AssaAsistencias",
        },
      ],
      asistencias: [],
    };
  },
  created() {
    this.verificarAuth();
  },
  methods: {
    verificarAuth() {
      let me = this;
      dbRefAppMovil.auth().onAuthStateChanged(function (user) {
        if (user) {
          me.logueado = true;
          me.cargarAsistencias();
        } else {
          me.logueado = false;
        }
      });
    },
    cargarAsistencias() {
      let me = this;
      dbAssa.on("value", function (snapshot) {
        me.asistencias = [];
        snapshot.forEach(function (element) {
          me.asistencias.push({
            poliza: element.val().poliza,
            tipoAsistencia: element.val().tipoAsistencia,
            pais: element.val().pais,
            titularPoliza: element.val().titularPoliza,
            placa: element.val().placa,
            marca: element.val().marca,
            modelo: element.val().modelo,
            color: element.val().color,
          });
        });
      });
    },
    cerrarSesion() {
      dbRefAppMovil
        .auth()
        .signOut()
        .then(function () {
          router.push({ name: "Home" });
        })
        .catch(function (error) {
          console.log("Hubo algun error", error);
        });
    },
  },
};
</script>
<style scoped>
.colorGradient {
  background: #56ccf2; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to left,
    #2f80ed,
    #56ccf2
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to left,
    #2f80ed,
    #56ccf2
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.v-breadcrumbs >>> a {
  color: rgb(255, 255, 255);
}
</style>